/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./copy-creative-dropdown.vue?vue&type=template&id=c23dd9f0&scoped=true&"
import script from "./copy-creative-dropdown.vue?vue&type=script&lang=js&"
export * from "./copy-creative-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./copy-creative-dropdown.vue?vue&type=style&index=0&id=c23dd9f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23dd9f0",
  null
  
)

export default component.exports